import axios from "axios";

export async function saveBandInfoAPI(bandInfo) {
  const name = bandInfo.name;
  const desc = bandInfo.desc;
  const location = bandInfo.location;
  const genre1 = bandInfo.genre1;
  const is_second_genre = bandInfo.is_second_genre;
  const genre2 = bandInfo.genre2;
  const bandPicture = bandInfo.bandPicture;
  const pictureCropJSON = JSON.stringify(bandInfo.pictureCrop);
  const pictureToUpload = bandInfo.pictureToUpload;

  const bandPictureFile = await fetch(bandPicture).then((res) => res.blob());

  const formData = new FormData();

  formData.append("file", bandPictureFile);

  formData.append("band_name", name);
  formData.append("band_desc", desc);
  formData.append("location", location);
  formData.append("genre1", genre1);
  formData.append("genre2", is_second_genre ? genre2 : "");
  formData.append("picture_crop", pictureCropJSON);
  formData.append("picture_to_upload", pictureToUpload);

  const metaData = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_BACKEND}/save_band`, formData, metaData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
}
